import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import routing from "routing";

import DefaultAuth from "../DefaultAuth";

const Form = styled((props) => {
	const { t } = useTranslation();

	return (
		<div className={props.className}>
			<p>{t("auth.resetPassword.linkUsed.subtitle")}</p>
			<Button
				variant="contained"
				fullWidth
				component={Link}
				to={routing.paths.resetPassword}
			>
				{t("auth.resetPassword.linkUsed.submit")}
			</Button>
		</div>
	);
})`
  p {
    color: #49454f;
    font-weight: 500;
    margin: 8px 0 16px;
  }
`;

export default function SetPasswordError() {
	const { t } = useTranslation();

	return (
		<DefaultAuth Form={Form} title={t("auth.resetPassword.linkUsed.title")} />
	);
}
